<template>
  <el-dialog title="关联商品批次"
             :visible.sync="visible"
             :width="enable ? '1180px' : '560px'"
             @closed='handleClose'
             :close-on-press-escape="false">
    <el-row :gutter="12">
      <el-col :span="enable ? 12: 24">
        <div style="text-align: left;margin-bottom: 10px;color:#000;line-height: 32px;font-size:18px">
          已选择：
        </div>
        <el-table border
                  ref="table"
                  row-key="batchId"
                  :height="enable ? '480px' : '360px'"
                  v-loading="loading"
                  :data="multipleSelection">
          <el-table-column label="商品批次号"
                           min-width="100"
                           prop="batchCode">
          </el-table-column>
          <el-table-column label="商品名称"
                           min-width="160"
                           prop="productName">
          </el-table-column>
          <el-table-column label="数量"
                           width="60"
                           prop="goodsCount">
          </el-table-column>
          <el-table-column label="操作"
                           fixed="right"
                           v-if="enable"
                           width="60">
            <template slot-scope="{ row, $index }">
              <el-button type="text"
                         :disabled="row.status === 3"
                         @click="deleteItem(row, $index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
      <el-col :span="12"
              v-if="enable">
        <div style="display: flex;align-items: center;justify-content: space-between;;margin-bottom: 10px;">
          <span style="color:#000;line-height: 32px;font-size:18px">请选择：</span>
          <div>
            <ent-product-auto-select v-model="config.productId"
                                     style="width: 180px;margin-right:10px"
                                     :callback="() => {handleCurrentChange(1)}" />
            <el-input placeholder="请输入批次编号"
                      v-model="config.batchCode"
                      clearable=""
                      style="width: 200px;">
              <el-button slot="append"
                         icon="el-icon-search"
                         @click="handleCurrentChange(1)"></el-button>
            </el-input>
          </div>
        </div>
        <el-table border
                  ref="table"
                  row-key="batchId"
                  height="480px"
                  v-loading="loading"
                  @selection-change="onSelectionChange"
                  :data="list">
          <el-table-column type="selection"
                           :selectable="row => !row.isAdded"
                           width="55">
          </el-table-column>
          <el-table-column label="商品批次号"
                           min-width="100"
                           prop="batchCode">
          </el-table-column>
          <el-table-column label="商品名称"
                           min-width="160"
                           prop="productName">
          </el-table-column>
          <el-table-column label="数量"
                           width="60"
                           prop="goodsCount">
          </el-table-column>
          <el-table-column label="操作"
                           fixed="right"
                           v-if="enable"
                           width="60">
            <template slot-scope="{ row, $index }">
              <el-button type="text"
                         :disabled="row.isAdded"
                         @click="addItem(row, $index)">{{ row.isAdded ? '已添加' : '添加' }}</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination background
                       style="text-align:center"
                       @current-change="handleCurrentChange"
                       :current-page.sync="config.pageNum"
                       :page-size="config.pageSize"
                       layout="total, prev, pager, next"
                       :total="total">
        </el-pagination>
      </el-col>
    </el-row>
    <span slot="footer">
      <el-button @click="addItems"
                 type="warning"
                 v-if="enable"
                 :disabled="selections.length === 0"
                 :loading="loading">批量选择已勾选批次</el-button>
      <el-button @click="toggleModal(false)"
                 :loading="loading">关闭</el-button>
      <el-button type="primary"
                 v-if="enable"
                 @click="handleSelectionChange"
                 :loading="loading">确定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { mapState } from 'vuex'
import clonedeep from 'lodash.clonedeep'
import EntProductAutoSelect from '@/components/business/ent-product-auto-select.vue'
export default {
  name: 'associate-product-batch-modal',
  components: { EntProductAutoSelect },
  props: {
    tradeType: [Number, String],
    vendorId: [Number, String],
    status: [Number, String]
  },
  data () {
    return {
      visible: false,
      loading: false,
      index: -1,
      row: {
        batchs: []
      },
      config: { pageNum: 1, pageSize: 50, batchCode: '', productId: null },
      list: [],
      total: 0,
      multipleSelection: [],
      selections: []
    }
  },
  computed: {
    ...mapState({
      userPermission: state => state.account.permission
    }),
    enable () {
      return (this.$route.path === '/inspect-detail' && this.status === 3 && this.userPermission.ENT) || this.$route.path === '/inspect-update' || this.$route.path === '/inspect-create'
    }
  },
  methods: {
    onSelectionChange (val) {
      this.selections = val
    },
    deleteItem (row, $index) {
      this.multipleSelection.splice($index, 1)
      this.countList(this.list)
      console.log(row, $index)
    },
    addItem (row, $index) {
      this.multipleSelection.push(JSON.parse(JSON.stringify(row)))
      this.countList(this.list)
      console.log(row, $index)
    },
    addItems () {
      const selections = this.selections
      this.multipleSelection.push(...JSON.parse(JSON.stringify(selections)))
      this.countList(this.list)
    },
    toggleModal (visible) {
      this.visible = visible
    },
    handleSelectionChange () {
      this.$emit('update:selection', this.index, this.multipleSelection)
      // this.toggleModal(false)
    },
    associate () {
      this.$refs.modal.toggleModal(true)
    },
    fetch (index, row) {
      console.log(index, row)
      this.row = { ...this.row, ...row, batchs: row.batchs || [] }
      this.index = index
      this.multipleSelection = clonedeep(row.batchs || [])
      this.toggleModal(true)
      if (this.enable) {
        this.fetchList()
      }
    },
    handleClose () {
      this.config.pageNum = 1
    },
    handleCurrentChange (current) {
      this.config.pageNum = current
      this.fetchList()
    },
    fetchList () {
      this.loading = true
      this.$store.dispatch('batch/getbatchs', {
        payload: {
          canAssociateInspectReport: this.userPermission.OPERATE ? null : 1,
          ...this.config,
          vendorId: this.vendorId,
          tradeType: this.tradeType,
          productIds: [this.row.productId]
        },
        success: (res) => {
          this.loading = false
          this.total = res.data.total
          // this.list = res.data.records
          this.countList(res.data.records)
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    countList (list) {
      this.list = list.map(i => {
        return { ...i, isAdded: this.multipleSelection.findIndex(s => s.batchId === i.batchId) > -1 }
      })
    }
  }
}
</script>
